<template>
    <div class="dashboard">
        <h1>Contact Dashboard</h1>
        <b-card footer-class="p-0" class="rounded-lg">
            <b-card-group deck>
                <b-card no-body class="border-0">
                    <chart-new-contacts />
                </b-card>
                <b-card no-body class="border-0">
                    <chart-total-active-companies />
                </b-card>
                <b-card no-body class="border-0">
                    <chart-total-active-contacts />
                </b-card>
            </b-card-group>
            <template v-slot:footer no-body>
                <b-tabs card class="list" content-class="rounded-lg">
                    <b-tab active>
                        <template v-slot:title>
                            <i class="famfamfam-silk cus-vcard"></i>Contact List
                        </template>
                        <b-card-text>
                            <contact-list />
                        </b-card-text>
                    </b-tab>
                </b-tabs>
            </template>
        </b-card>
    </div>
</template>
<script>
import "@/jquery/jquery.flot"; // for the charts

export default {
    components: {
        ContactList: () => import("@/components/contacts/contact-list"),
        ChartNewContacts: () =>
            import("@/components/contacts-charts/new-contacts"),
        ChartTotalActiveCompanies: () =>
            import("@/components/contacts-charts/total-active-companies"),
        ChartTotalActiveContacts: () =>
            import("@/components/contacts-charts/total-active-contacts")
    },
    data() {
        return {
            resources: {}
        };
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {}
};
</script>
